import { type ApiClientResponse, apiClient, routes } from 'common/services';

type EventFeedbackRequestData = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  audio_rating?: number;
  audio_text?: string;
  helpful_rating?: number;
  helpful_text?: string;
  provider_rating?: number;
  provider_text?: string;
  recommend_rating?: number;
  recommend_text?: string;
  video_rating?: number;
  video_text?: string;
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
};

export const createEventFeedback = async (id: string, data: EventFeedbackRequestData) =>
  apiClient.post<undefined, ApiClientResponse<undefined>>(routes.events.createFeedback(id), {
    events_feedback: data,
  });
